module.exports = __webpack_public_path__ + "static/media/omnicure_logo.a7933a66.svg";